import type { MapBoundaryAreaQueryRequest } from '~/store/boundaryItems/boundaryItems.repository';

export enum FileExportResult {
  Success = 'Success',
  Error = 'Error',
  Pending = 'Pending',
}

export enum FileExportType {
  BoundaryAreaQuery = 'BoundaryAreaQuery',
}

export type FileExportId = Uuid;

export type FileExport = Readonly<{
  id: FileExportId;
  resultPages: ReadonlyArray<FileExportResults>;
  name: string;
  type: FileExportType.BoundaryAreaQuery;
  request: MapBoundaryAreaQueryRequest;
}>;

export type FileExportResults = Readonly<{
  type: FileExportResult.Success;
  fileUrl?: string;
  data?: string;
  error: null;
} | {
  type: FileExportResult.Error;
  fileUrl: undefined;
  data: undefined;
  error: string;
} | {
  type: FileExportResult.Pending;
  fileUrl: undefined;
  data: undefined;
  error: null;
}>;

export type ProcessingState = Readonly<{
  mapSettingsSyncInProgress: boolean;
  mapSettingsSyncFailed: boolean;
  spreadsheetDataFetchingInProgress: boolean;
  isGoogleScriptInitialized: boolean;
  imageExportInProgress: boolean;
  initialMarkersRendered: boolean;
  initialBoundariesRendered: boolean;
  renderingMarkers: boolean;
  areFileAttachmentsSynced: boolean;
  firstZoomLevel: number | null;
  exportImageModeInitialized: boolean;
  exports: ReadonlyArray<Readonly<FileExport>>;
}>;
